import { format } from 'date-fns'
import { CalendarDaysIcon } from 'lucide-react'
import React, { useEffect, useState } from 'react'
// import { DateRange } from 'react-day-picker';

import { Button } from '../ui/button'
import { Calendar } from '../ui/calendar'
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover'

import { cn } from '@/lib/utils'

export function DateRangePicker({ className, field }) {
  const [date, setDate] = useState()

  useEffect(() => {
    setDate(field?.value ?? null)
  }, [field?.value])

  return (
    <div className={cn('grid gap-2', className)}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            id="date"
            variant="outline"
            className={cn(
              'w-full justify-start text-left font-normal bg-white border-input-border-color px-3 py-6 rounded-sm text-muted-foreground',
              !date && 'text-muted-foreground'
            )}
          >
            {date?.from ? (
              date.to ? (
                <>
                  {format(date.from, 'LLL dd, y')} - {format(date.to, 'LLL dd, y')}
                </>
              ) : (
                format(date.from, 'LLL dd, y')
              )
            ) : (
              <span>Pick a date range</span>
            )}
            <CalendarDaysIcon className="ml-auto h-4 w-4" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 bg-transparent shadow-none" align="start">
          <Calendar
            captionLayout="dropdown-buttons"
            fromYear={1960}
            toYear={2030}
            initialFocus
            mode="range"
            defaultMonth={date?.from}
            selected={date}
            onSelect={(value) => {
              setDate(value)
              field?.onChange(value)
            }}
            numberOfMonths={2}
          />
        </PopoverContent>
      </Popover>
    </div>
  )
}
